export type PlanningResolutionView = 'MOBILE' | 'DESKTOP';
